export default __webpack_public_path__ + "static/media/aurum-video-library.79ac0be7.svg";